module.exports = __webpack_public_path__ + "static/media/star.cf33ec77.svg";